<mat-card style="height: -webkit-fill-available">
    <mat-card-header>
      <mat-card-title><h1>Company Risk</h1></mat-card-title>
    </mat-card-header>
    <mat-card-content style="height:250px;">
      <mat-list style="height:inherit; overflow:auto;">
        <mat-list-item *ngFor="let company of companyData">
          <span style="padding-right:20px;">{{ company.name }}</span>
          <mat-chip-list style="margin-left: auto;">
            <mat-chip [ngStyle]="{'background-color': getRiskColor((company.x + company.y) / 2)}">{{ getRiskLabel((company.x + company.y) / 2) }}</mat-chip>
          </mat-chip-list>
          <mat-divider></mat-divider>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
    <!-- <mat-card-footer>
      <mat-chip-list>
        <mat-chip *ngFor="let lvl of riskGradient; let idx = index" [ngStyle]="{'background-color': lvl}">{{ idx }}</mat-chip>
      </mat-chip-list>
    </mat-card-footer> -->
  </mat-card>